import React from 'react';
import styled from 'styled-components';
import { RSSFeed, FeedOptions } from '../types/rss';
import { NewsCard } from './NewsCard';
import { NewsListItem } from './NewsListItem';

interface NewsListProps {
  feed: RSSFeed | null;
  options: FeedOptions;
  loading: boolean;
  error: string | null;
  currentTickerIndex?: number;
}

const Container = styled.div`
  padding: 20px 0;
`;

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

const ListLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 18px;
`;

const ErrorContainer = styled.div`
  color: #dc3545;
  text-align: center;
  padding: 20px;
  border: 1px solid #dc3545;
  border-radius: 4px;
  margin: 20px 0;
`;

const RefreshButton = styled.button`
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 16px;
  
  &:hover {
    background-color: #0056b3;
  }
`;

export const NewsList: React.FC<NewsListProps> = ({ feed, options, loading, error, currentTickerIndex = -1 }) => {
  if (loading) {
    return (
      <LoadingContainer>
        <div className="loading">Carregando notícias...</div>
      </LoadingContainer>
    );
  }

  if (error) {
    return (
      <ErrorContainer>
        <div className="error">{error}</div>
      </ErrorContainer>
    );
  }

  if (!feed || !feed.items || feed.items.length === 0) {
    return (
      <ErrorContainer>
        <div className="error">Nenhuma notícia encontrada.</div>
      </ErrorContainer>
    );
  }

  return (
    <Container>
      {options.layout === 'grid' && (
        <GridLayout>
          {feed.items.map((item, index) => (
            <NewsCard 
              key={`${item.link}-${index}`} 
              item={item} 
              showImage={options.showImages}
              isHighlighted={index === currentTickerIndex}
            />
          ))}
        </GridLayout>
      )}

      {options.layout === 'list' && (
        <ListLayout>
          {feed.items.map((item, index) => (
            <NewsListItem 
              key={`${item.link}-${index}`} 
              item={item} 
              showImage={options.showImages}
              isHighlighted={index === currentTickerIndex}
            />
          ))}
        </ListLayout>
      )}

      {options.layout === 'card' && (
        <GridLayout>
          {feed.items.map((item, index) => (
            <NewsCard 
              key={`${item.link}-${index}`} 
              item={item} 
              showImage={options.showImages}
              isHighlighted={index === currentTickerIndex}
            />
          ))}
        </GridLayout>
      )}
    </Container>
  );
};